import { create } from 'zustand';
import { ApiUtils, ProfileApi, UpdateProfileRequest } from '@shared/api';
import i18n from 'i18n';

interface UseUpdateProfileStore {
  loading: boolean;
  error?: string | null;
  success: boolean | null;
  update: (request: UpdateProfileRequest, accountId: number) => void;
  clear: () => void;
}

export const useUpdateProfileStore = create<UseUpdateProfileStore>((set) => ({
  loading: false,
  error: null,
  success: null,

  update: async (request: UpdateProfileRequest, accountId: number) => {
    try {
      set({ loading: true, error: null, success: null });
      await ProfileApi.updateProfile(request, accountId);
      set({ loading: false, success: true });
      return { loading: false, success: true };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, error });
      return { loading: false, error };
    }
  },

  clear: () => set({ loading: false, error: null, success: null }),
}));
